<template>
  <app-page-container middle>
    <app-spinner v-if="!is_page_loaded"/>
    <template v-else>
      <app-cells>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
        <app-input
          v-model="search_hotel"
          class="input--300"
          type="search"
          placeholder="Search by hotel"
          name="search"
        />
      </app-cells>
      <v-client-table
        :data="filteredHotelTable"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__hotel>
          <div class="table-default__left">Hotel</div>
        </template>
        <template #hotel="{ row }">
          <div class="table-default__left">{{ row.hotel_name }}</div>
        </template>
        <template #bednights="{ row }">{{ row.count }}</template>
        <template></template>
      </v-client-table>
    </template>
  </app-page-container>
</template>

<script>
import { getReservationsAnalyticsHotelsBednights } from '@/http'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'ReservationAnalyticsBednight',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_page_loaded: false,
      table: {
        items: [],
        columns: ['hotel', 'bednights'],
        options: {
          headings: {
            hotel: 'Hotel',
            bednights: 'Bednights'
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'last30Days', label: 'Last 365 days', value: 365 },
        {
          key: 'year2025',
          label: 'Year 2025',
          value: () => {
            return {
              start: moment('2025-01-01'),
              end: moment('2025-12-31')
            }
          }
        },
        {
          key: 'next365Days',
          label: 'Next 365 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(365, 'days')
            }
          }
        },
        { key: 'thisYear', label: 'This year', value: 'year' },
        {
          key: 'nextYear',
          label: 'Next year',
          value: () => {
            const nextYear = moment().add(1, 'year').year()
            return {
              start: moment().year(nextYear).startOf('year'),
              end: moment().year(nextYear).endOf('year')
            }
          }
        }
      ],
      filter_dates: null,
      search_hotel: '',
    }
  },
  computed: {
    filteredHotelTable() {
      return this.table.items.filter(item => {
        return this.search_hotel ? item.hotel_name.toLowerCase().includes(this.search_hotel.toLowerCase()) : this.table.items
      })
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
    fetchItems() {
      this.is_page_loaded = false
      getReservationsAnalyticsHotelsBednights({ from_date: this.filter_dates?.start, to_date: this.filter_dates?.end })
        .then(res => {
          this.table.items = res.data
          this.is_page_loaded = true
        })
    }
  }
}
</script>
